import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FoodService, OrganizationService, SupplementService, UserService } from 'src/app/services';
import { Food, Organization, Supplement, User } from 'src/app/models';
import { safeFindIndex } from 'src/app/utils';

@Component({
  selector: 'app-supplement-select',
  templateUrl: './supplement-select.component.html',
  styleUrls: ['./supplement-select.component.scss'],
})
export class SupplementSelectComponent implements OnInit {

  public activeUser: User;
  public categories: any;
  public categoryCount: {
    [categoryId: string]: number
  };
  public organization: Organization;
  public systemFoods: any = [];
  public filter = true;
  public filteredSupplements: Supplement[] = [];
  public filters: any = {};
  public filterType = "all";
  public searchTerm = "";
  public selectedSupplements: Food[] = [];
  public supplements: Supplement[];
  public isVisited = false;
  public maxLimit = 10;

  @Input() organizationId: string;
  @Input() userId: string;

  constructor(
    private foodsService: FoodService,
    private modalCtrl: ModalController,
    private organizationService: OrganizationService,
    private supplementService: SupplementService,
    private userService: UserService,
  ) {
    this.activeUser = this.userService.getAppUser();
    this.organization = this.organizationService.getAppOrganization();
  }

  async ngOnInit() {  
   
  }   

  async ionViewDidEnter(){
    this.loadSupplements();
  }
  
  async loadSupplements() {
    this.supplements = await this.supplementService.getOrganizationSupplementsAsPromise(this.organizationId);
    this.filterChanged();
  }

  filterChanged() {
    this.filterSupplements();
    this.resetLimit();
  }

  filterSearch(supplement: Supplement): Boolean {
    if (!this.filters.searchTerm) {
      return true
    } else {
      let name = `${supplement.title} ${supplement.brand}`;
      return name.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1;
    }
  }

  filterSupplements() {
    this.filteredSupplements = (this.supplements || [])
      .filter((supplement) => {
        return this.filterSearch(supplement)
      })
      .sort((a, b) => {
        return a.title.localeCompare(b.title)
      });
  }

  isSupplementSelected(foodId) {
    return safeFindIndex(this.selectedSupplements, s => s.id === foodId) > -1
  }

  toggleSupplement(food: Food) {
    if (this.isSupplementSelected(food.id)) {
      this.removeSupplement(food.id);
    } else {
      this.selectSupplement(food);
    }
  }

  selectSupplement(food) {
    this.selectedSupplements.push(food);
  }

  removeSupplement(foodId) {
    const index = safeFindIndex(this.selectedSupplements, s => s.id === foodId);
    if (index > -1) {
      this.selectedSupplements.splice(index, 1);
    }
  }

  done() {
    this.modalCtrl.dismiss({supplements: this.selectedSupplements}, "selected");
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }

  filterSlide() {
    this.isVisited = !this.isVisited;
  }

  resetLimit() {
    this.maxLimit = 10;
  }

  loadData(event) {
    setTimeout(() => {
      this.maxLimit += 10;
      event.target.complete();
    }, 250)
  }

  isUserTrainer() {
    return this.userService.getAppUser() && this.organizationService.getAppOrganization()?.isUserTrainer(this.userService.getAppUser().uid);
  }

}
